import { Box, Typography } from '@mui/material';

const StatCard = ({ title, value, icon, color, subtitle }) => {
  return (
    <Box
      sx={{
        bgcolor: '#ffffff',
        borderRadius: '16px',
        p: 3,
        height: '100%',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)',
        border: '1px solid rgba(226,232,240,0.8)',
        transition: 'transform 0.22s ease, box-shadow 0.22s ease',
        cursor: 'default',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
          transform: 'translateY(-3px)',
          boxShadow: `0 8px 32px rgba(0,0,0,0.09), 0 0 0 1.5px ${color}30`,
        },
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          height: '3px',
          background: color,
          borderRadius: '16px 16px 0 0',
        },
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2.5 }}>
        <Typography
          sx={{
            fontSize: '0.72rem',
            fontWeight: 700,
            letterSpacing: '0.07em',
            textTransform: 'uppercase',
            color: '#94A3B8',
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            width: 42,
            height: 42,
            borderRadius: '12px',
            bgcolor: `${color}12`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: color,
            flexShrink: 0,
            '& svg': { fontSize: 22 },
          }}
        >
          {icon}
        </Box>
      </Box>

      <Typography
        sx={{
          fontSize: '2.4rem',
          fontWeight: 800,
          color: '#0F172A',
          lineHeight: 1,
          mb: 0.75,
          letterSpacing: '-0.03em',
        }}
      >
        {value ?? '—'}
      </Typography>

      {subtitle && (
        <Typography
          sx={{
            fontSize: '0.8rem',
            color: '#64748B',
            mt: 0.75,
            fontWeight: 500,
          }}
        >
          {subtitle}
        </Typography>
      )}
    </Box>
  );
};

export default StatCard;
